import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BilldiscountResponseService {

  constructor(private httpClient: HttpClient) { }

  TOKEN = 'Bearer ' + window.localStorage.getItem('token');


  billdiscount_accept(company_id: any,Kredxcustname:any) {
    const userId = window.localStorage.getItem('user_id');
    const headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': this.TOKEN });
    return this.httpClient.get(`${environment.api_rul}/sendbilldiscount_acceptmail/?company_id=` + company_id + `&Kredxcustname=` + Kredxcustname);
  }
}
